var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendlePtWsteth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_643)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.011,
    cy: 124.919,
    rx: 106,
    ry: 108.5,
    transform: "rotate(-3 118.011 124.919)",
    fill: "url(#paint0_linear_28_643)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.989,
    cy: 124.081,
    rx: 106,
    ry: 108.5,
    transform: "rotate(-3 133.989 124.081)",
    fill: "#00A3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.195 117.699L100.34 119.141C90.5345 136.419 94.0004 158.124 109.127 171.302C117.46 179.247 128.825 182.843 139.971 182.259C139.971 182.259 139.971 182.259 101.195 117.699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M137.537 135.818L101.171 117.234C139.971 182.259 139.971 182.259 139.971 182.259C139.216 167.862 138.34 151.144 137.537 135.818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.785 113.999L172.787 115.344C184.344 131.503 183.166 153.451 169.5 168.138C161.578 176.935 151.116 181.675 139.971 182.259C139.971 182.259 139.97 182.259 171.785 113.999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.537 135.818L171.76 113.535C139.97 182.259 139.97 182.259 139.97 182.259C139.216 167.862 138.34 151.144 137.537 135.818Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.176 90.7711L137.001 125.601L166.751 106.812L135.176 90.7711Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M135.176 90.7711L105.45 110.025L137.001 125.601L135.176 90.7711Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.643 61.5137L105.45 110.025L135.176 90.7711L133.643 61.5137Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M135.176 90.7711L166.751 106.812L133.642 61.5137L135.176 90.7711Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.851 118.795C237.848 175.989 195.001 224.526 139.406 227.439C83.8105 230.353 36.1248 186.561 33.1274 129.367C30.13 72.1737 72.977 23.6367 128.572 20.7231C184.167 17.8095 231.853 61.6019 234.851 118.795Z",
    stroke: "url(#paint1_linear_28_643)",
    strokeWidth: 10
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 50,
    r: 50,
    fill: "url(#paint2_radial_28_643)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.747 33.1472C189.006 33.1472 191.002 33.6555 192.734 34.6722C194.504 35.6889 195.859 37.1197 196.801 38.9648C197.78 40.8099 198.269 42.9185 198.269 45.2907C198.269 47.6253 197.78 49.6963 196.801 51.5037C195.859 53.2734 194.504 54.6478 192.734 55.6268C191.002 56.6058 189.006 57.0954 186.747 57.0954H180.647C180.459 57.0954 180.365 57.1895 180.365 57.3778V72.0629C180.365 72.2512 180.289 72.4207 180.139 72.5713C180.026 72.6842 179.875 72.7407 179.687 72.7407H173.078C172.89 72.7407 172.721 72.6842 172.57 72.5713C172.457 72.4207 172.401 72.2512 172.401 72.0629V33.825C172.401 33.6367 172.457 33.4861 172.57 33.3731C172.721 33.2225 172.89 33.1472 173.078 33.1472H186.747ZM185.448 50.7694C186.916 50.7694 188.084 50.2987 188.95 49.3574C189.853 48.3784 190.305 47.0793 190.305 45.4602C190.305 43.8034 189.853 42.4855 188.95 41.5065C188.084 40.5274 186.916 40.0379 185.448 40.0379H180.647C180.459 40.0379 180.365 40.1321 180.365 40.3204V50.487C180.365 50.6753 180.459 50.7694 180.647 50.7694H185.448ZM227.145 33.2037C227.334 33.2037 227.484 33.279 227.597 33.4296C227.748 33.5426 227.823 33.6932 227.823 33.8815V39.4166C227.823 39.6049 227.748 39.7744 227.597 39.925C227.484 40.0379 227.334 40.0944 227.145 40.0944H218.56C218.372 40.0944 218.278 40.1886 218.278 40.3768V72.0629C218.278 72.2512 218.202 72.4207 218.052 72.5713C217.939 72.6842 217.788 72.7407 217.6 72.7407H210.992C210.803 72.7407 210.634 72.6842 210.483 72.5713C210.37 72.4207 210.314 72.2512 210.314 72.0629V40.3768C210.314 40.1886 210.22 40.0944 210.031 40.0944H201.729C201.54 40.0944 201.371 40.0379 201.22 39.925C201.107 39.7744 201.051 39.6049 201.051 39.4166V33.8815C201.051 33.6932 201.107 33.5426 201.22 33.4296C201.371 33.279 201.54 33.2037 201.729 33.2037H227.145Z",
    fill: "#1C293A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.088 250C227.654 250 250 227.614 250 200C250 172.386 227.654 150 200.088 150C172.522 150 150.176 172.386 150.176 200C150.176 227.614 172.522 250 200.088 250Z",
    fill: "url(#paint3_radial_28_643)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 150,
    width: 100,
    height: 100
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.912 250C227.478 250 249.824 227.614 249.824 200C249.824 172.386 227.478 150 199.912 150C172.346 150 150 172.386 150 200C150 227.614 172.346 250 199.912 250Z",
    fill: "#DEDEDE"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_643)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.458 274.996C192.622 274.996 204.916 262.681 204.916 247.489C204.916 232.298 192.622 219.982 177.458 219.982C162.293 219.982 149.999 232.298 149.999 247.489C149.999 262.681 162.293 274.996 177.458 274.996Z",
    fill: "#152E51"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 152,
    width: 7,
    height: 75
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.437 226.554V152.836H180.558V226.554H174.437Z",
    fill: "#152E51"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.824 200C249.824 227.615 227.478 250 199.912 250C172.346 250 150 227.615 150 200C150 172.386 172.346 150 199.912 150C227.478 150 249.824 172.386 249.824 200Z",
    fill: "#152E51"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_643",
    x1: 118.011,
    y1: 16.4187,
    x2: 118.011,
    y2: 233.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_643",
    x1: 128.311,
    y1: 15.73,
    x2: 139.667,
    y2: 232.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_28_643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.241 23.6111) rotate(134.346) scale(86.1024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E2FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_28_643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(174 230.5) rotate(-52.0284) scale(78.0144 77.8771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendlePtWsteth);
export default __webpack_public_path__ + "static/media/pendle-pt-wsteth.75171336c7e74733c54211c83f21a5ac.svg";
export { ForwardRef as ReactComponent };